import { render } from "./CustomerDomainsList.vue?vue&type=template&id=600cd19e"
import script from "./CustomerDomainsList.vue?vue&type=script&lang=js"
export * from "./CustomerDomainsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__